<!--
 * @Author: your name
 * @Date: 2020-11-12 17:40:42
 * @LastEditTime: 2022-11-03 16:54:39
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/BottomPopupDialog/index.vue
-->
<style scoped lang="sass">
.box
  display: flex
  flex-direction: column
  align-items: center
  padding-bottom: 60px
  min-height: 80vh
  max-height: 80vh

  &.box_pickup
    min-height: 50vh

  &.box_delivery
    min-height: 70vh

.tabs
  margin-top: 18px
  width: 100%

  ::v-deep
    .tab
      &.active
        color: var(--menu-primary-background-colour)
        background: rgba(var(--menu-primary-background-colour-rgb), 0.1)

        .icon
          color: var(--menu-primary-background-colour) !important

      &:first-child
        border-right: none

.pickup_icon,
.delivery_icon
  margin-top: 16px
  width: 114px
  height: 114px

  &.size_90
    width: 90px
    height: 90px

.pickup_content
  font-size: 14px

  .title
    margin-top: 20px
    text-align: center
    color: #000
    font-weight: bold

  .text
    margin-top: 5px
    text-align: center
    color: #595959

.address_input
  width: 100%

  ::v-deep
    .mu-input
      margin-bottom: 0
      padding-bottom: 0
      min-height: 0

.wait_time
  margin-top: 14px
  font-size: 14px

  .title
    text-align: center
    color: #000
    font-weight: bold

  .text
    margin-top: 5px
    text-align: center
    color: #595959

.tag_box
  margin-top: 20px
  width: 100%

  .tag
    display: flex
    align-items: center
    padding: 8px 10px
    background: rgba(6, 163, 65, .05)
    border: 1px solid rgba(6, 163, 65, .25)
    border-radius: 4px

    .tag_icon
      margin-right: 10px
      width: 20px
      height: 20px
      font-size: 20px
      transform: rotate(90deg)

    .tag_text
      font-size: 12px
      color: #000

      .text
        display: inline

      .b
        font-weight: 500

.order_type
  margin-top: 10px
  color: #334455

  .img_box
      width: 113px
      margin: auto
      padding-bottom: 10px

  .order_type_title
    margin-bottom: 6px
    font-size: 14px
    font-weight: bold
    .text_middle
        text-align: center
        margin-bottom: -25px

  .order_type_box
    height: 80px

    .venue_address
      display: flex
      justify-content: center
      align-items: center
      padding-top: 24px

      .address_text
        margin-left: 4px
        font-size: 12px

.later_time
  margin-top: 10px
  width: 100%

  .input_icon
    display: flex
    margin-right: 6px
    color: var(--menu-primary-background-colour) !important

  ::v-deep
    .mu-select
      cursor: pointer

      // placeholder 的样式
      .mu-select-input::-webkit-input-placeholder
        color: #000
        opacity: 1

    .py_form_item_box,
    .has-label
      padding-bottom: 0
      min-height: 0

.no_time_tag,
.off_delivery
  margin-top: 20px
  padding: 8px 10px
  display: flex
  align-items: center
  width: 100%
  font-size: 12px
  background: rgba(176, 6, 32, .05)
  border: 1px solid rgba(176, 6, 32, .25)
  border-radius: 4px

  .icon
    margin-right: 10px
    width: 18px
    height: 18px

.no_now_time
  width: 100%

  .earliest_available_time
    margin-top: 20px
    text-align: center
    font-size: 12px
    color: var(--menu-primary-background-colour)
    text-decoration: underline
    cursor: pointer

.date_select
  ::v-deep
    .mu-select
      cursor: pointer

.foot_button_box
  position: fixed
  display: flex
  justify-content: center
  align-items: center
  left: 0
  bottom: 0
  display: flex
  justify-content: center
  align-items: center
  padding: 0 16px
  width: 100%
  height: 80px
  border-top: 1px solid rgba(51, 68, 85, .1)

  .foot_button
    width: 100%

  ::v-deep
    .van-button--disabled
      background-color: #ddd
      opacity: 1

</style>

<template lang="pug">
bottom-popup-dialog(v-model="visible" :title="dialogTitle" :showCloseIcon="!!title")
  .box(slot="popup-dialog" :class="[{box_pickup: !dialogType}, {box_delivery: dialogType === 1}]")
    img.pickup_icon(
      v-if="!dialogType || dialogType === 2"
      :class="{size_90: dialogType === 2}"
      src="@/assets/delivery-info-dialog/pickup.png"
    )
    img.delivery_icon(
      v-if="dialogType === 1 || dialogType === 3"
      :class="{size_90: dialogType === 3}"
      src="@/assets/delivery-info-dialog/delivery.png"
    )
    tabs.tabs(
      v-if="dialogType >= 4"
      v-model="orderType"
      :titleList="orderTypeTitleList"
      :iconList="orderTypeIconList"
      blok
    )
    .pickup_content(v-if="showPickupContent")
      .title PICKUP FROM
      .text {{ venueAddress }}
    .off_delivery(v-if="orderType && isOffDelivery")
      icon.icon(color="#B00620") announcement
      | Delivery is currently unavailable.

    .address_input(v-if="showAddressInput && !isOffDelivery")
      py-form(
        ref="userForm"
        :model="userInfo"
        :rules="userRuleValidate"
      )
        py-form-item(prop='userAddress')
          address-input(
            :value="userInfo.userAddress"
            :address.sync="userInfo.userAddress"
            :oldRawAddress.sync="oldUserInfo.rawAddress"
            :oldAddress.sync="oldUserInfo.address"
            :oldPostcode.sync="oldUserInfo.postcode"
            :postcode.sync="userPostcode"
            :rawAddress.sync="rawAddress"
            @submitUserAddress="submitUserAddress"
          )
    tabs.tabs(
      v-if="showScheduledTimeTab && scheduledTimeTitleList.length"
      v-model="scheduledTime"
      :titleList="scheduledTimeTitleList"
      blok
    )
    .no_time_tag(
      v-if="isVenueHomeNoNowTime && !(orderType && isOffDelivery)"
      :style="{'margin-top': `${ !orderType ? 20 : 0 }px`}"
    )
      icon.icon(color="#B00620") announcement
      div
        span(v-if="!isOriginalVenueOpenTime") We are currently closed.&nbsp
        span You can only pre-order for later.
    .wait_time(v-if="showWaitTime && !showNoNowTime")
      .title ESTIMATED WAIT TIME:
      .text {{ nowDeliveryTime | timeFilter }}
    .later_time(v-if="showLaterTime")
      py-form(
        ref="timeForm"
        :model="userLater"
        :rules="timeRuleValidate"
      )
        py-form-item(v-show="showDateForm" prop='laterDate')
          mu-select.date_select(
            :value="getLaterDate"
            placeholder="Select a date"
            label="Scheduled date"
            full-width
            readonly
            @click.native="showDateSelect = !showDateSelect"
          )
            div(slot="prepend")
              icon.input_icon date_range
          select-bottom-popup(
            v-model="showDateSelect"
            :show="showDateSelect"
            :data="userLater.laterDate"
            :dataList="dateList"
            type="date"
            @select="selectDate"
          )

        py-form-item(prop='laterTime')
          mu-select.time_select(
            :value="userLater.laterTime"
            placeholder="Select a time"
            label="Scheduled time"
            full-width
            readonly
            @click.native="showTimeSelect = !showTimeSelect"
          )
            div(slot="prepend")
              icon.input_icon query_builder

          select-bottom-popup(
            v-model="showTimeSelect"
            :data="userLater.laterTime"
            :show="showTimeSelect"
            :dataList="timeList"
            type="time"
            @select="selectTime"
          )

    .tag_box(v-if="deliveryType === 'local' && orderType && !isOffDelivery")
      .tag(
        v-for="(item, index) in venueDeliverySetting.conditionRule"
        v-if="item.showOffer"
        :key="index"
      )
        icon(color="#06A341").tag_icon sell
        .tag_text
          .tag_text_item
            .text.b {{ conditionBase(item.baseFee) + ' ' }}
            .text on orders over {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ item.minDeliveryAmount }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}.
    .no_time_tag(v-if="showNoTimeTag")
      icon.icon(color="#B00620") announcement
      | No pre-order times available

    .no_now_time(v-if="showNoNowTime")
      .no_time_tag
        icon.icon(color="#B00620") announcement
        | {{ orderType ? 'Delivery' : 'Pickup' }} now is unavailable.
      .earliest_available_time(v-if="availableTime" @click="setEarliestAvailableTime")
        span {{ 'Order for earliest available time: ' }}
        span.b {{ availableTime }}

    .foot_button_box
      van-button.foot_button(type="primary" :disabled="disabledSubmit" @click="submit") {{ buttonTitle }}
    loading(v-if="showLoading")
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import AddressInput from 'components/AddressInput'
import SelectBottomPopup from 'components/SelectBottomPopup'
import Loading from './Loading'
import { mapState, } from 'vuex'
import mixin from '@/utils/mixin'
import { safeDecodeURI } from 'utils'
import dayjs from 'dayjs'
import { deliveryTime } from 'utils/gooleMpas'
import { getDeliveryCost, getVenue } from '@/api/product'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  props: {
    title: String,
    isVenueCloseTime: Boolean, // Whether the current restaurant is closed. True means closed    // 当前餐厅是否为关闭状态，值为 'true' 时是关闭状态。
  },

  components: {
    AddressInput,
    SelectBottomPopup,
    Loading
  },

  computed: {
    ...mapState({
      isOnline: state => state.app.isOnline,
      venueAddress: state => state.venueHome.pickupSettings && state.venueHome.pickupSettings.pickupAddress && state.venueHome.pickupSettings.pickupAddress !== '' ? state.venueHome.pickupSettings.pickupAddress : state.venueHome.address,
      venueDeliverySetting: state => state.venueHome.deliverySetting,
      venueAverageWaitingTime: state => state.venueHome.averageWaitingTime,
      venueSystemDefaultWaitingTime: state => state.venueHome.systemDefaultWaitingTime,
      venuePeakWaitingTimes: state => state.venueHome.peakWaitingTimes,
      deliveryInfo: state => state.contactDetails.deliveryInfo,
      preOrderSettings: state => state.venueHome.preOrderSettings,
    }),
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },

    /**
     * The user needs to manually add the url parameter enableThirdTest=true
     * @returns { Boolean } Whether the current route parameter enableThirdTest is true
     */
    /**
     * 用户需要手动添加 url 参数: 'enableThirdTest = true'
     * @returns { Boolean } 当前路由参数 'enableThirdTest' 是否为 'true'
     */
    enableThirdTest() {
      const enableThirdTest = this.$route.query?.enableThirdTest ?? false
      return enableThirdTest === 'true'
    },

    venueId() {
      return this.$store.state.venueId ?? this.$route.params.venueId
    },

    /**
     * @returns { Boolean } The current page is a product list page and now is not optional
     */
    /**
     * @returns { Boolean } 当前页面是商品列表页, 并且不能选择 'now' 选项
     */
    isVenueHomeNoNowTime() {
      // Is currently on the VenueHome page
      // 当前是否在 'VenueHome' 页面
      const isVenueHome = this.$route.name === 'venue-home-pick'
      // Whether the order limit reaches the limit
      // 订单限制数量是否达到限制状态
      let isOrderThrottling = false
      if (this.orderThrottlingSettings?.enable) {
        const nowTime = dayjs.tz().add(this.nowDeliveryTime, 'm').format('YYYY-MM-DD HH:mm')
        isOrderThrottling = this.orderThrottlingSettings?.statusInfo?.find((item) => dayjs(nowTime).isSame(item.fromTime) || (dayjs(nowTime).isBetween(item.fromTime, item.toTime, 'minute')))?.isLimited ?? false
      }
      // Is it optional todayA
      // 是否能选择今天
      let passToday = true
      if (dayjs.tz().isSame(this.dateList[0]?.value ?? '', 'day') && !(this.dateList[0]?.available ?? false)) passToday = false
      const isNoNowTime = !this.isOriginalVenueOpenTime || isOrderThrottling || !passToday
      return isVenueHome && isNoNowTime
    },

    /**
     * @returns { Number } Pop up window type
     *  0: pickup
     *  1: delivery
     *  2: pickup + pre
     *  3: delivery + pre
     *  4: pickup + delivery
     *  5: pickup + delivery + pre
     */
    /**
     * @returns { Number } 弹窗的类型
     *  0: pickup
     *  1: delivery
     *  2: pickup + pre
     *  3: delivery + pre
     *  4: pickup + delivery
     *  5: pickup + delivery + pre
     */
    dialogType() {
      if (this.enablePickup && !this.enableDelivery && !this.enablePreOrder) {
        this.orderType = 0
        return 0
      }
      if (!this.enablePickup && this.enableDelivery && !this.enablePreOrder) {
        this.orderType = 1
        return 1
      }
      if (this.enablePickup && !this.enableDelivery && this.enablePreOrder) {
        this.orderType = 0
        return 2
      }
      if (!this.enablePickup && this.enableDelivery && this.enablePreOrder) {
        this.orderType = 1
        return 3
      }
      if (this.enablePickup && this.enableDelivery && !this.enablePreOrder) return 4
      if (this.enablePickup && this.enableDelivery && this.enablePreOrder) return 5
    },

    /**
     * @returns { String } Delivery delivery type
     *  Local: Merchant distribution
     *  ThirdParty: Third party delivery
     */
    /**
     * @returns { String } delivery 配送类型
     *  local：商家配送
     *  thirdParty：第三方配送
     */
    deliveryType() {
      return this.venueDeliverySetting?.type ?? 'local'
    },

    /**
     * @returns {Boolean} Show pickup template
     */
    /**
     * @returns {Boolean} 是否要显示 pickup 的模版
     */
    showPickupContent() {
      if (!this.dialogType || this.dialogType === 2) return true
      if (this.dialogType === 5 && !this.orderType) return true
      return false
    },

    /**
     * @returns {Boolean} Show Toggle Time Type Label
     */
    /**
     * @returns {Boolean} 是否要显示 '切换时间类型' 的标签
     */
    showScheduledTimeTab() {
      if (this.dialogType === 2) return true
      if (this.dialogType === 3) {
        if (this.userInfo.userAddress && !this.isOutsideAddress) return true
      }
      if (this.dialogType === 5) {
        if (!this.orderType || (this.orderType && this.userInfo.userAddress && !this.isOutsideAddress)) return true
      }
      return false
    },

    /**
     * @returns {Boolean} Display waiting time template
     */
    /**
     * @returns {Boolean} 是否要显示 '等待时间' 的模版
     */
    showWaitTime() {
      if (this.dialogType === 0) return true
      if (this.dialogType === 1) return this.orderType === 1 && this.userInfo.userAddress && !this.isOutsideAddress
      if (this.dialogType === 2 && !this.scheduledTime) return true
      if (this.dialogType === 3 && this.userInfo.userAddress && !this.isOutsideAddress && !this.scheduledTime) return true
      if (this.dialogType >= 4) {
        if ((!this.orderType || (this.orderType && this.userInfo.userAddress && !this.isOutsideAddress)) && !this.scheduledTime) return true
      }
      return false
    },

    /**
     * @returns {Boolean} Show Shipping Address Input Box
     */
    /**
     * @returns {Boolean} 是否要显示 '配送地址' 的输入框
     */
    showAddressInput() {
      if (this.dialogType === 1 || this.dialogType === 3) return true
      if (this.dialogType >= 4 && this.orderType) return true
      return false
    },

    /**
     * @returns {Boolean} Display later time template
     */
    /**
     * @returns {Boolean} 是否要显示 'later time' 的模版
     */
    showLaterTime() {
      // The scheduled date is today only, and there is no available time. The system returns false directly
      // 预定日期只有今天的时候，并且没有可选择的时间，则直接返回 'false'
      if (this.dateList.length === 1 && !this.dateList[0].available) return false
      if ((this.scheduledTime && this.enablePreOrder && this.dateList.find(item => item.available))) {
        if (this.dialogType === 2) return true
        if (this.dialogType === 3) {
          if (this.userInfo.userAddress && !this.isOutsideAddress) return true
        }
        if (this.dialogType === 5) {
          if ((!this.orderType || (this.orderType && this.userInfo.userAddress && !this.isOutsideAddress))) return true
        }
      }
      return false
    },

    /**
     * @returns {Boolean} Display tags with no pre order time to select
     */
    /**
     * @returns {Boolean} 显示没有可选择 pre-order 时间的标签
     */
    showNoTimeTag() {
      return this.scheduledTime && (!this.dateList.length || (this.dateList.length === 1 && !this.dateList[0].available))
    },

    /**
     * @returns {Boolean} Whether the restaurant is closed delivery
     */
    /**
     * @returns {Boolean} 餐厅是否已经关闭 delivery 的功能
     */
    isOffDelivery() {
      const nowTime = dayjs.tz().format('YYYY-MM-DD HH:mm:ss')
      const startTime = this.venueDeliverySetting?.pauseSetting?.startTime ?? ''
      const endTime = this.venueDeliverySetting?.pauseSetting?.endTime ?? ''
      if (nowTime === startTime ||
          nowTime === endTime ||
          dayjs(nowTime).isBetween(startTime, endTime, 's')
      ) return this.venueDeliverySetting?.pauseSetting?.enable ?? false
      return false
    },

    /**
     * @returns {Boolean} No time available now
     */
    /**
     * @returns {Boolean} 是否有现在可选的时间
     */
    showNoNowTime() {
      // When delivering, the user address is filled in and displayed after passing
      // 当为 delivery 时，填写用户地址并且检验通过后，才显示内容
      let isPassUserAddress = !this.orderType
      let isOrderThrottling = false
      if (this.userInfo.userAddress && !this.isOutsideAddress) isPassUserAddress = true
      if (this.orderThrottlingSettings?.enable) {
        const nowTime = dayjs.tz().format('YYYY-MM-DD HH:mm')
        isOrderThrottling = this.orderThrottlingSettings?.statusInfo?.find((item) => dayjs(nowTime).isSame(item.fromTime) || (dayjs(nowTime).isBetween(item.fromTime, item.toTime, 'minute')))?.isLimited ?? false
      }
      let passToday = true // Whether all dates are optional   // 日期是否都可选
      if (this.enablePreOrder && this.dateList.findIndex(item => item.available) < 0) passToday = false
      return !this.scheduledTime && isPassUserAddress && (!this.isOriginalVenueOpenTime || isOrderThrottling || !passToday) && !this.isVenueHomeNoNowTime
    },

    /**
     * @returns {Boolean} Disable submit button
     */
    /**
     * @returns {Boolean} 禁用'提交按钮'
     */
    disabledSubmit() {
      return !!((this.orderType && this.isOffDelivery && this.dialogType !== 1 && this.dialogType !== 3) || this.showNoNowTime || (this.orderType === 1 && !this.userInfo.userAddress))
    },

    /**
     * @returns {Boolean} Display the later date selection box
     */
    /**
     * @returns {Boolean} 是否显示 'later date' 的选择框
     */
    showDateForm() {
      return this.showLaterTime && this.dateList.length && !(this.dateList.length === 1 && this.dateList[0].value === dayjs.tz().format('YYYY-MM-DD'))
    },

    /**
     * @returns {String} Pop up header title
     */
    /**
     * @returns {String} 弹窗头部的标题文案
     */
    dialogTitle() {
      if (this.title) return this.title
      if (!this.dialogType || this.dialogType === 2) return 'Start your pickup order'
      if (this.dialogType === 1 || this.dialogType === 3) return 'Start your delivery order'
      if (this.dialogType >= 4) return 'Start your order'
    },

    /**
     * @returns {Boolean} Whether the selected laterDate is today
     */
    /**
     * @returns {Boolean} 选择的 'laterDate' 是否是今天
     */
    isToday() {
      return dayjs(this.userLater.laterDate).format('YYYY-MM-DD') === dayjs.tz().format('YYYY-MM-DD')
    },

    /**
     * @return {String} Get the last date filled in by the user
     */
    /**
     * @return {String} 获取用户上一次填写的日期
     */
    getLaterDate() {
      const dateObj = this.dateList.find(item => item.value === this.userLater.laterDate)
      return dateObj?.label ?? ''
    },

    /**
     * Display different tag lists according to restaurant settings
     * @return {Array} Get the time type tag list
     */
    /**
     * 根据餐厅的设置，展示不同的标签列表
     * @return {Array} 获取 '时间类型标签' 的列表
     */
    scheduledTimeTitleList() {
      if (this.preOrderSettings?.enable ?? false) {
        return this.isVenueHomeNoNowTime ? [] : ['NOW', 'LATER']
      } else {
        return []
      }
    },

    /**
     * Display different tag lists according to restaurant settings
     * @return {Array} Get the takeout type tag list
     */
    /**
     * 根据餐厅设置，展示不同的标签列表
     * @return {Array} 获取 '外卖类型标签' 的列表
     */
    orderTypeTitleList() {
      return this.venueDeliverySetting?.enableDelivery ? ['PICKUP', 'DELIVERY'] : ['PICKUP']
    },

    /**
     * @return {Array} Get the zip code list of takeout delivery set by the restaurant
     */
    /**
     * @return {Array} 获取餐厅设置的 '外卖的配送邮编' 列表
     */
    venuePostcodeList() {
      return this.venueDeliverySetting?.areaSettings?.postcodes
    },

    /**
     * @return {Number} Total waiting time set by the restaurant
     */
    /**
     * @return {Number} 餐厅设置的等待总时间
     */
    nowDeliveryTime() {
      // If venueAverageWaitingTime is off, the default setting is 10 minutes
      // 若 'venueAverageWaitingTime' 为关闭状态，则默认设置为 10 分钟
      const venueAverageWaitingTime = this.venueAverageWaitingTime ? this.venueAverageWaitingTime : 600
      let time = Number(venueAverageWaitingTime) + Number(this.venueSystemDefaultWaitingTime)
      // Plus delivery time calculated by Google
      // 加上谷歌计算的配送时间
      if (this.orderType) {
        if (this.deliveryType === 'local') {
          time += Number(this.googleDeliveryTime ?? 0)
        } else {
          time += Number(this.deliveryCost?.timeCost ?? 0)
        }
      }
      return (time / 60).toFixed()
    },

    /**
     * @return {String} Bottom button text
     */
    /**
     * @return {String} 底部按钮的文案
     */
    buttonTitle() {
      let text = 'ORDER PICKUP'
      if (this.orderType || this.dialogType === 1 || this.dialogType === 3) text = this.isOffDelivery ? 'VIEW OUR MENU ANYWAY' : `ORDER DELIVERY - MIN. $${this.venueDeliverySetting?.minDeliveryAmount}`
      return text
    },

    /**
     * @return {String} Latest optional pre order time
     */
    /**
     * @return {String} 最近可选的 'pre-order' 时间
     */
    availableTime() {
      const dateObj = this.dateList.find(item => item.available)
      const isToday = dayjs(dateObj?.value).format('YYYY-MM-DD') === dayjs.tz().format('YYYY-MM-DD')
      // If the optional date is not today, an empty string is returned
      // 若可选日期不是今天，则返回空字符串
      if (!isToday) return ''
      this._setTimeList()
      const timeObj = this.timeList.find(item => item.available)
      return timeObj?.value ?? ''
    }
  },

  watch: {
    visible: {
      async handler(val) {
        if (val) { // When the pop-up window of this component is displayed   // 显示本组件的弹窗时
          const hasPreOrder = this.enablePreOrder && !!this.dateList.length && !this.showNoTimeTag
          // If pickup and delivery or now and later are unavailable, this pop-up window will not be displayed, and the closing pop-up window will be displayed
          // 若 (pickup 和 delivery) 或 (now 和 later) 都不可用，则不展示本弹窗，并且展示 '停业弹窗'
          if ((!(this.enableDelivery && !this.isOffDelivery) && !this.enablePickup) || !(!this.isVenueHomeNoNowTime || hasPreOrder) || (this.enablePreOrder && this.dateList.findIndex(item => item.available) < 0)) {
            // The product can be browsed, and the disabled button cannot be added to the shopping cart
            // 商品可浏览，禁用按钮，并且不可添加到购物车
            this.$store.commit('saveOnlineDisabledButton', true)
            // If it is displayed today that the take out pop-up window is closed, it will not be displayed again
            // 若今天显示过 '关闭外卖弹窗'，则不再显示此弹窗。
            if (this._checkIsNotToday()) this.$emit('showCloseTimeDialog')
            this.visible = false
            // Record the time when the pop-up window of the takeout system is closed
            // 记录 '外卖系统停业弹窗' 出现的时间
            this.$store.commit('venueClosePopupOnceTime/SET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME', dayjs.tz().format('YYYY-MM-DD'))
            return
          }
          this.$store.commit('saveOnlineDisabledButton', false)
          // Clear the time when the pop-up window of the takeout system is closed
          // 清除 '外卖系统停业弹窗' 出现的时间
          this.$store.commit('venueClosePopupOnceTime/DEL_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME')
          this._getVenueSettings()
          await this._verificationPreOrderTime()
          this.$emit('showDeliveryVisible', this.visible)
        } else {
          this.$emit('showDeliveryVisible', this.visible)
        }
      },
      immediate: true
    },

    currentTimeSettings(val) {
      const dateList = val.map(item => ({
        label: dayjs(item.date).format('dddd DD MMM'),
        value: item.date,
        hourSettings: item.hourSettings,
        available: item.hourSettings?.length ? item.available : false,
      }))

      // Judge whether it is optional today
      // 判断今天是否可以选择
      if (dateList[0]?.available) {
        const timeList = this._filterTimeList(dateList[0].value, dateList)
        // If there is no optional time today, treat today's date as unavailable
        // 若今天没有可选时间，则不可选择今天日期
        if (!timeList.length) dateList[0].available = false
      }
      if (dateList.length && !dateList.find(item => (item.value === this.userLater.laterDate) && item.available)) this.userLater.laterDate = dateList.find(item => item.available)?.value ?? ''

      this.dateList = dateList
    },

    isVenueCloseTime: {
      handler(val) {
        if (val) { // If the restaurant is closed, pre order is selected by default   // 若现在餐厅是关闭状态，默认选择 'pre-order' 选项
          this.scheduledTime = 1
          if (!this.preOrderSettings?.enable) this.scheduledTime = 0
        }
      },
      immediate: true
    },

    orderType() {
      // When switching orderType, the current selection is recorded and the latest selection is automatically filled in
      // 切换成 'orderType' 时，记录本次的选择，并且自动填写最近的选择。
      const data = {
        scheduledTime: this.scheduledTime,
        laterDate: this.userLater.laterDate,
        laterTime: this.userLater.laterTime,
      }
      if (this.lastScheduledTimeData) {
        this.scheduledTime = this.lastScheduledTimeData.scheduledTime
        this.userLater.laterDate = this.lastScheduledTimeData.laterDate
        this.userLater.laterTime = this.lastScheduledTimeData.laterTime
      }
      this.lastScheduledTimeData = data
      // Recalculate the delivery time list after PICKUP and DELIVERY switch
      // 'PICKUP' 和 'DELIVERY' 切换后，重新计算 '配送时间列表'
      if (this.scheduledTime === 1 && this.userLater.laterDate) this._setTimeList()
    },

    deliveryInfo: {
      handler(val) {
        if (val) { // If the takeout information has been filled in, pre fill it   // 若填写过外卖信息，则预填写信息
          this._setDeliveryInfo(val[this.venueId])
        }
      },
      immediate: true
    },

    dateList: {
      handler(val) { // When the date list has a value, calculate the time list   // 日期列表有值时，计算对应的 '时间列表'
        if (val.length) this._setTimeList()
      },
      immediate: true
    },

    scheduledTimeTitleList: { // If the scheduledTimeTitleList changes, pre select the appropriate tab   // 'scheduledTimeTitleList' 发生变化时，预选适合的 tab 选项
      handler(newVal, oldVal) {
        if (newVal?.length !== oldVal?.length && this._.isArray(newVal) && this._.isArray(oldVal)) {
          if (!newVal.length && (this.preOrderSettings?.enable ?? false)) this.scheduledTime = 1
          else this.scheduledTime = 0
        }
      },
      immediate: true
    },

    'userLater.laterDate': {
      handler() {
        // After the user selects a date, calculate the time list of the corresponding date
        // 用户选择日期后，计算对应日期的时间列表
        this._setTimeList()
      },
      immediate: true
    }
  },

  filters: {
    /**
     * @returns {String} Time format from seconds to minutes or hours
     */
    /**
     * @returns {String} 以秒为单位的时间，转换成以分钟或小时为单位的时间格式
     */
    timeFilter(val) {
      const hour = parseInt(val / 60)
      const mins = val % 60
      let time = ''
      if (hour > 0) time += `${hour} hour `
      time += `${mins} minutes `
      return time
    }
  }
})

class DeliveryInfoDialog extends mixins(mixin) {
  visible = false // Display this pop-up window   // 是否显示本弹窗
  isOutsideAddress = false // Whether the shipping address is within the shipping range   // 配送地址是否在配送范围内
  showDateSelect = false // Display date selection list   // 显示日期选择的列表
  showTimeSelect = false // Show time selection list   // 显示时间选择的列表
  showLoading = false // Show Load Animation   // 是否显示加载动画
  orderType = 0 // Order Type  0: pickup 1: delivery   // 订单类型 0: pickup 1: delivery
  orderTypeIconList = ['shopping_bag', 'delivery_dining'] // Icon list of order type // 订单类型的 icon 列表
  scheduledTime = 0 // Order time type 1: now 2: later   // 订单时间类型 1: now 2: later
  lastScheduledTimeData = null // Record the latest data selection when switching orderType   // 记录切换 orderType 时，最近一次选择的数据

  // Old shipping address information
  // 旧的配送地址信息
  oldUserInfo = {
    rawAddress: '',
    address: '',
    postcode: '',
  }

  rawAddress = '' // User's shipping address information (returned by google map)   // 用户的配送地址信息（由 google map 返回数据）
  googleDeliveryTime = 0 // Delivery time calculated by google map   // google map 计算的配送时间

  userLater = { // User's scheduled time   // 用户的预定时间
    laterDate: '', // default to today
    laterTime: ''
  }

  userPostcode = '' // User's shipping zip code   // 用户的配送邮编
  userInfo = { // User's shipping address   // 用户的配送地址
    userAddress: ''
  }

  userRuleValidate = { // Shipping Address Form Validation Rules   // 配送地址表单的验证规则
    userAddress: [
      { required: true, message: 'Address is required', trigger: 'blur' },
      { validator: this._isOutsideAddress, trigger: 'blur' }
    ],
  }

  timeRuleValidate = { // Delivery preselected date form validation rules   // 配送预选日期表单的验证规则
    laterDate: [{ required: true, message: 'Date is required', trigger: 'blur' }],
    laterTime: [{ required: true, message: 'Time is required', trigger: 'blur' }],
  }

  isVenuePostcode = true // Whether the delivery address meets the delivery range of the restaurant   // 配送地址是否满足餐厅的配送范围
  enablePickup = false // Whether to enable pickup   // 是否开启 pickup
  enableDelivery = false // Enable delivery   // 是否开启 delivery
  enablePreOrder = false // Enable preOrder   // 是否开启 preOrder
  deliveryCost = {} // Information related to third-party distribution   // 第三方配送的相关信息
  currentTimeSettings = [] // Back end calculated delivery time list   // 后端计算的配送时间列表
  dateList = [] // Scheduled Date List   // 预定日期的列表
  timeList = [] // Scheduled time list   // 预定时间的列表
  timeSegment = 900 // Optional time interval set by the restaurant   // 餐厅设置的可选时间的间隔时间
  orderThrottlingSettings = null // Order limit settings for restaurants   // 餐厅的订单限制设置
  todayNoLaterTime = false // There is no time to choose today   // 是否今天没有可选的时间

  mounted() {
    this._getVenueSettings()
    this.__checkVenueOpenTime()
    if (this.isOnline) this._verificationPreOrderTime()
  }

  /**
   * Select the latest available delivery time
   * @param {Number} scheduledTime Selected order time type button
   */
  /**
   * 选择最近可用的配送时间
   * @param {Number} scheduledTime 选中的订单时间类型按钮
   */
  setEarliestAvailableTime(scheduledTime = 1) {
    this.scheduledTime = scheduledTime
    const date = this.dateList.find(item => item.available)
    this.selectDate(date?.value ?? '')
    this.selectTime(this.availableTime)
  }

  /**
   * Conditional pricing service fee
   * @param conditionBaseFee { String } Conditional service charge
   * @returns {String} Final service charge to be displayed
   */
  /**
   * Conditional pricing 服务费
   * @param conditionBaseFee { String } Conditional 的服务费
   * @returns {String} 最终要展示的服务费
   */
  conditionBase(conditionBaseFee) {
    const deliveryBaseFee = Number(this.venueDeliverySetting.baseFee)
    if (Number(conditionBaseFee) > deliveryBaseFee) {
      const symbol = getCurrencySymbol()
      const position = getSymbolPosition()
      const formatted = formatDecimalNumber(deliveryBaseFee)
      return position === 'after' ? `${formatted} ${symbol}` : `${symbol}${formatted}`
    }
    return Number(conditionBaseFee) ? 'For discounted delivery' : 'FREE DELIVERY'
  }

  /**
   * Select date
   * @param val {String} Selected date
   */
  /**
   * 选择日期
   * @param val {String} 选择的日期
   */
  selectDate(val) {
    this.userLater.laterDate = val
    this.showDateSelect = false
  }

  /**
   * Select time
   * @param val {String} Selected time
   */
  /**
   * 选择时间
   * @param val {String} 选择的时间
   */
  selectTime(val) {
    this.userLater.laterTime = val
    this.showTimeSelect = false
  }

  /**
   * Get delivery time
   * @param start {String} Restaurant address
   * @param end {String} Delivery address filled in by the user
   */
  /**
   * 获取配送时间
   * @param start {String} 餐厅地址
   * @param end {String} 用户填写的配送地址
   */
  async getDeliveryTime(start, end) {
    if (!this.isOnline) return
    this.googleDeliveryTime = await deliveryTime(start, end).catch(error => {
      console.log(error)
      this.$createNotify({
        $props: {
          message: 'Unable to get the correct shipping address, please try again.',
          type: 'danger',
        },
      }).show()
      this.isOutsideAddress = true
      this.showLoading = false
    })
  }

  // Submit the user's shipping address
  // 提交用户的配送地址
  submitUserAddress() {
    if (this.userInfo.userAddress !== this.oldUserInfo.address) {
      this.userPostcode = ''
      this.rawAddress = ''
    } else {
      this.userPostcode = this.oldUserInfo.postcode
      this.rawAddress = this.oldUserInfo.rawAddress
    }
    this._verifyUserPostcode(this.userPostcode)
  }

  /**
   * Submit Form
   */
  /**
   * 提交表单
   */
  async submit() {
    let isPassTime = true
    let isPassAddress = true
    if (this.scheduledTime && this.$refs.timeForm) this.$refs.timeForm.validate(async (valid) => isPassTime = valid)
    if ((this.orderType || this.dialogType === 1) && this.$refs.userForm) { this.$refs.userForm.validate(async (valid) => isPassAddress = valid) }
    this.showLoading = true
    if (!(isPassTime && isPassAddress && await this._getDeliveryCost())) {
      this.showLoading = false
      return
    }
    this._addDeliveryInfo()
    this.$emit('submit')
    this.showLoading = false
    this._hide()
  }

  // Add DeliveryInfo to vuex
  // 添加 DeliveryInfo 到 vuex
  _addDeliveryInfo() {
    const deliveryInfo = {
      address: this.userInfo.userAddress,
      userPostcode: this.userPostcode,
      type: this.scheduledTime ? 3 : 0,
      orderType: this.orderType ? 'delivery' : 'pickup',
      preOrderTimeSettings: this.scheduledTime ? dayjs(this.userLater.laterDate + this.userLater.laterTime).format('YYYY-MM-DD HH:mm:ss') : '',
      waitTime: this.nowDeliveryTime,
      rawAddress: this.rawAddress,
      googleDeliveryTime: this.orderType ? this.googleDeliveryTime : 0,
      deliveryCost: this.deliveryCost
    }
    this.$store.commit('addDeliveryInfo', deliveryInfo)
  }

  // Get restaurant settings
  // 获取餐厅的设置
  async _getVenueSettings() {
    const { settings } = await getVenue({ id: safeDecodeURI(this.$route.params.venueId) }).catch(error => {
      console.log(error)
      this.showLoading = false
    })
    this.orderThrottlingSettings = settings?.orderThrottlingSettings ?? {}
    this.timeSegment = Number(settings?.orderThrottlingSettings?.timeSegment ?? 900)
    this.enablePickup = settings?.pickupSettings?.enableTakeaway ?? settings?.options?.takeaway ?? false
    this.enableDelivery = settings?.deliverySettings?.enableDelivery ?? false
    this.enablePreOrder = settings?.preOrderSettings?.enable ?? false
    this.currentTimeSettings = settings?.preOrderSettings?.currentTimeSettings ?? []
  }

  // Call component function externally to display pop-up window
  // 外部调用组件函数，用于显示弹窗
  _show() {
    this.visible = true
  }

  // Call the component function externally to close the pop-up window
  // 外部调用组件函数，用于关闭弹窗
  _hide() {
    this.visible = false
  }

  /**
   * Assign value to DeliveryInfo
   * @param deliveryInfo {Object} Value to assign to DeliveryInfo
   * @param isSetDeliveryCost {Boolean} Whether to assign a value to deliveryCost
   */
  /**
   * 给 DeliveryInfo 赋值
   * @param deliveryInfo {Object} 要赋给 DeliveryInfo 的值
   * @param isSetDeliveryCost {Boolean} 是否要给 deliveryCost 赋值
   */
  _setDeliveryInfo(deliveryInfo, isSetDeliveryCost = true) {
    if (!deliveryInfo) return
    this.orderType = Number(deliveryInfo.orderType === 'delivery')
    if (this.venueDeliverySetting?.enableDelivery === false) this.orderType = 0 // force use pickup
    this.rawAddress = deliveryInfo.rawAddress
    this.userInfo.userAddress = deliveryInfo.address
    this.userPostcode = deliveryInfo.userPostcode
    this.googleDeliveryTime = deliveryInfo.googleDeliveryTime
    this.scheduledTime = Number((deliveryInfo.preOrderTimeSettings ?? 0) && deliveryInfo.preOrderTimeSettings !== 'Invalid Date')
    this.userLater.laterDate = (deliveryInfo.preOrderTimeSettings && deliveryInfo.preOrderTimeSettings !== 'Invalid Date') ? dayjs(deliveryInfo.preOrderTimeSettings).format('YYYY-MM-DD') : ''
    this.userLater.laterTime = (deliveryInfo.preOrderTimeSettings && deliveryInfo.preOrderTimeSettings !== 'Invalid Date') ? dayjs(deliveryInfo.preOrderTimeSettings).format('HH:mm') : ''
    if (this.preOrderSettings?.enable === false) this.scheduledTime = 0 // force to use now
    if (isSetDeliveryCost) this.deliveryCost = deliveryInfo?.deliveryCost ?? {}
  }

  /**
   * @returns {Boolean} Is the pop up time for takeout closing today
   */
  /**
   * @returns {Boolean} '外卖关闭弹窗' 的弹窗时间是不是今天
   */
  _checkIsNotToday() {
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const lastTime = this._getVenueClosePopupOnceTime()
    return nowTime !== lastTime
  }

  /**
   * Get the pop-up time for taking out closing
   * @returns {String} Pop up time for takeout closing
   */
  /**
   * 获取 '外卖关闭弹窗' 的弹窗时间
   * @returns {String} '外卖关闭弹窗' 的弹窗时间
   */
  _getVenueClosePopupOnceTime() {
    this.$store.commit('venueClosePopupOnceTime/GET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME')
    return this.$store.state.venueClosePopupOnceTime.onlinePopupTime
  }

  // Form verification, whether the shipping address is within the shipping range
  // 表单验证，配送地址是否在配送范围内
  _isOutsideAddress(rule, value, callback) {
    this.isOutsideAddress ? callback(new Error('This address is outside of our delivery zone')) : callback()
  }

  // Verify the advance order time. If the time is equal to or before the current time, clear the data
  // 校验预订单时间，若时间等于或在现在时间之前，则清空数据
  _verificationPreOrderTime() {
    const deliveryInfo = JSON.parse(JSON.stringify(this.deliveryInfo))
    const nowTime = dayjs.tz()
    const preOrderTimeSettings = deliveryInfo?.preOrderTimeSettings
    // If there is no advance order time, stop running
    // 若不存在预订单时间，则停止运行
    if (!preOrderTimeSettings) return
    // Initialize preOrderTimeSettings when the advance order time is equal to or before the current time
    // 若预订单时间等于或在现在时间之前，则初始化 'preOrderTimeSettings'
    if (this.preOrderSettings?.enable && dayjs(preOrderTimeSettings).isSameOrBefore(nowTime)) {
      deliveryInfo.preOrderTimeSettings = ''
      this.$store.commit('addDeliveryInfo', deliveryInfo)
      this.visible = true
      this.scheduledTime = 1
    }
  }

  /**
   * Verify whether the shipping address is available
   * @param val {String} Shipping Address Postal Code
   */
  /**
   * 校验配送地址是否可用
   * @param val {String} 配送地址邮编
   */
  async _verifyUserPostcode(val) {
    this.showLoading = true
    this.isVenuePostcode = !!val
    this.userLater.laterDate = ''
    this.userLater.laterTime = ''
    this.isOutsideAddress = false
    if (val) {
      const isDelivery = this.venuePostcodeList.find(item => item.postcode === val)
      this.isVenuePostcode = !!isDelivery
      if (isDelivery) {
        if (this.userInfo.userAddress) {
          // The local delivery takes the delivery time calculated by Google, and the third-party delivery calls the API to get the delivery time
          // 若是本地配送，则取 google 计算的配送时间。若是第三方配送，则调取 API 获取配送时间。
          if (this.deliveryType === 'local') await this.getDeliveryTime(this.venueAddress, this.userInfo.userAddress)
          else await this._getDeliveryCost()
        }
      } else {
        this.isOutsideAddress = true
        this.$createNotify({
          $props: {
            message: 'Unable to update delivery address. This address is outside of our delivery zone.',
            type: 'danger',
          },
        }).show()
        this.showLoading = false
      }
    } else {
      this.isOutsideAddress = true
      this.$createNotify({
        $props: {
          message: 'Unable to update delivery address. This address is outside of our delivery zone.',
          type: 'danger',
        },
      }).show()
      this.showLoading = false
    }
    if (!this.isOutsideAddress) this._initScheduledTime()
    this.showLoading = false
  }

  /**
   * Get third-party information according to user address
   * @returns {Boolean} Whether the interface is called successfully
   */
  /**
   * 根据用户地址，获取第三方的信息
   * @returns {Boolean} 接口是否调取成功
   */
  async _getDeliveryCost() {
    if (!this.rawAddress || this.deliveryType === 'local' || !this.orderType) return true
    const rawAddress = JSON.parse(this.rawAddress)
    const addressInfo = {
      latitude: rawAddress.geometry.location.lat,
      longitude: rawAddress.geometry.location.lng,
      googleObject: rawAddress
    }
    const userId = localStorage.getItem('userId') ?? ''
    let orderTime = dayjs.tz().add(this.nowDeliveryTime, 'm').format('YYYY-MM-DD HH:mm:ss')
    if (this.userLater.laterDate && this.userLater.laterTime) orderTime = `${this.userLater.laterDate} ${this.userLater.laterTime}:00`

    const data = await getDeliveryCost({
      venueId: this.venueId,
      addressInfo,
      userId,
      orderInfo: {
        orderTime,
        orderType: 'delivery'
      }
    }).catch(error => {
      console.log(error)
      this.showLoading = false
    })
    this.deliveryCost = data?.deliveryInfo ?? {}
    return data ?? false
  }

  // Initialize and select time related data
  // 初始化选择时间的相关数据
  _initScheduledTime() {
    const date = this.enablePreOrder ? this.dateList.find(item => item.available) : null
    this.userLater.laterDate = this.selectDate(date?.value ?? '')
    this.userLater.laterTime = ''
    this.setEarliestAvailableTime(0)
  }

  // Assignment selection time list
  // 赋值选择时间列表
  _setTimeList() {
    this.timeList = this._filterTimeList(this.userLater.laterDate, this.dateList)
    this._verifyLaterTime()
  }

  /**
   * Time list corresponding to filtering date
   * @param laterDate {String} Corresponding date
   * @param dateList {Array} Date List
   * @returns {Array} Time List
   */
  /**
   * 筛选日期对应的时间列表
   * @param laterDate {String} 对应日期
   * @param dateList {Array} 日期列表
   * @returns {Array} 时间列表
   */
  _filterTimeList(laterDate, dateList) {
    // Get the corresponding time list according to the selected date
    // 根据选择的日期，获取对应的时间列表
    if (!laterDate) return []
    let timeList = dateList.find(item => item.value === laterDate)?.hourSettings ?? []
    // If there is no optional date today, the timeList setting is empty
    // 若今天没有可选日期，清空 timeList
    if (!timeList.length) {
      return []
    }
    timeList = timeList.filter(item => item.available)
    // Format Time List
    // 格式化时间列表
    timeList = timeList.map(item => ({
      available: item.available,
      label: item.fromHour + (item.noOrderLeft ? ` (${item.noOrderLeft} orders left)` : ''),
      value: item.fromHour,
    }))

    let startTime = timeList[0].value
    // If venueAverageWaitingTime is off, the default setting is 10 minutes
    // 若 venueAverageWaitingTime 为关闭状态，则默认设置为 10 分钟
    const venueAverageWaitingTime = this.venueAverageWaitingTime ? this.venueAverageWaitingTime : 600
    const waitingTime = Number(venueAverageWaitingTime) + Number(this.venueSystemDefaultWaitingTime)
    const nowTimeAddWaitingTime = dayjs.tz().add(waitingTime, 's').format('YYYY-MM-DD HH:mm')
    // If the date and the date selected by the user are not the same day after the current time plus the waiting time, the timeList setting is empty
    // 若当前时间加上等待时间后，日期和用户选择日期不在同一天，则情况 timeList
    if (dayjs(laterDate).isBefore(nowTimeAddWaitingTime, 'day')) {
      return []
    }
    // If the selected date is today, and the current time+waiting time is later than the first optional time, the start time is assigned to the current time+waiting time
    // 若选择的日期是今天，并且 '现在时间 + 等待时间' 要比第一个可选时间晚，则开始时间赋值成 '现在时间 + 等待时间'
    if (this.isToday && dayjs(`2000-01-01 ${dayjs(nowTimeAddWaitingTime).format('HH:mm')}`).isSameOrAfter(`2000-01-01 ${startTime}`, 's')) startTime = dayjs(nowTimeAddWaitingTime).format('HH:mm')
    // Delivery time
    // 配送时间
    let deliveryTime = 0
    if (this.userInfo.userAddress && this.orderType === 1) {
      if (this.deliveryType === 'local') {
        deliveryTime = Number(this.googleDeliveryTime ?? 0)
      } else {
        deliveryTime = Number(this.deliveryCost?.timeCost ?? 0)
      }
    }

    // The delivery time is added to the start time to calculate the new start time
    // 开始时间加上配送时间，计算出新的开始时间
    startTime = dayjs(`2000-01-01 ${startTime}`).add(deliveryTime, 's').format('HH:mm')
    // The time format is formatted into the same string type as the API
    // 时间格式格式化成和 API 相同的 string 类型
    let startHour = Number(startTime.split(':')[0])
    let startMinute = Number(startTime.split(':')[1])
    if (!(startMinute % 60)) {
      startMinute = 0
    } else {
      // StartMinute is calculated according to the minute interval set by the restaurant
      // 根据餐厅设置的分钟间隔，计算 startMinute
      const minuteSegment = this.timeSegment / 60
      for (let number = 0; minuteSegment * number <= 60; number++) {
        if ((startMinute % 60) <= (minuteSegment * number)) {
          if (minuteSegment * number === 60) {
            // When minute approaches the next hour, it will be counted as the next full hour. Example: Now it is 9:58, and it should be calculated as 10:00
            // 当分钟临近下一小时，则计算成下一整时。例：现在是 9:58，要计算成 10:00
            startHour++
            startMinute = 0
          } else {
            startMinute = minuteSegment * number
            break
          }
        }
      }
    }

    startHour = startHour < 10 ? '0' + startHour : startHour
    startMinute = startMinute < 10 ? '0' + startMinute : startMinute

    // Intercept a new time list according to the new start time
    // 根据新的开始时间，截取新的时间列表
    const index = timeList.findIndex(item => dayjs(`2000-01-01 ${item.value}`).isSameOrAfter(`2000-01-01 ${startHour}:${startMinute}`, 'm'))
    if (index >= 0) timeList = timeList.slice(index, timeList.length)
    else timeList = []

    // If the latest time is not optional, it will not be displayed
    // 若最近的时间不可选，则不展示不可选的时间
    const availableIndex = timeList.findIndex(item => item.available)
    if (availableIndex >= 0) timeList = timeList.slice(availableIndex, timeList.length)
    else timeList = []

    return timeList
  }

  // Verify whether the user time is available, and clear the time if it is not available
  // 校验用户时间是否可用，不可用就清空时间
  _verifyLaterTime() {
    if (!this.timeList.find(item => item.value === this.userLater.laterTime)) this.userLater.laterTime = ''
  }
}

export default DeliveryInfoDialog
</script>
